/* eslint-disable no-unused-vars */
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { BrowserRouter as Router, useRoutes } from 'react-router-dom'
import { Amplify, Hub } from 'aws-amplify'
import { Authenticator } from '@aws-amplify/ui-react'
import MuiAlert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import axios from 'axios'

import AccountDeactivated from './components/account-deactivated'
import ChangePassword from './components/authentications/change-password'
import EcgModal from './components/ecg-component/ecg-modal'
import EchoModal from './components/ESN/echo-component/echo-modal'
import StressEchoModal from './components/ESN/stress-echo-component/stress-echo-modal/index'
import NuclearModal from './components/ESN/nuclear-component/nuclear-modal'
import CathModal from './components/CCM/cath-component/cath-modal'
import GxtModal from './components/gxt-component/gxt-modal'
import HolterModal from './components/holter-component/holter-modal'
import LabsModal from './components/labs-component/labs-modal'
import ResetPassword from './components/authentications/reset-password'
import SessionExpired from './components/session-expired'
import VitalModal from './components/vital-component/vital-modal'
import awsExports from './aws-config'
import { loginComponents, loginFormFields } from './pages/login/cognito'
import { removeAlert, setAlert } from './redux/alert/alert.action'
import CtModal from './components/CCM/ct-component/ct-modal'
import MriModal from './components/CCM/mri-component/mri-modal'
import CardiacModal from './components/medications/cardiac-component/cardiac-modal'
import SocialModal from './components/social-history/social-modal'
import FamilyModal from './components/family-history/family-modal'
import ConsultModal from './components/consult-notes/consult-modal'
import AdverseEventModal from './components/adverse-event/adverse-modal'
// import IntervalModal from './components/interval-history/interval-modal'
// import PhysicalModal from './components/physical-exam/physical-modal'
import MedicalHistoryModal from './components/medical-history/medical-modal/index'
import CardiacHistoryModal from './components/cardiac-history/cardiac-modal/index'
import CardiacTimelineModal from './components/cardiac-history/cardiac-timeline-modal/index'
// import RecommendationsModal from './components/recommendations/recommendations-modal/RecommendationsModal'
import ConsultLetterModal from './components/consult-letter/consult-letter-modal/index'
import ScreenFlowModal from './components/screen-flow/screen-flow-modal'
import EligibilityCriteriaModal from './components/portal-components/EligibilityCriteriaModal'
import AppointmentListModal from './components/portal-components/AppointmentListModal'
import PatientInfoModal from './components/portal-components/PatientInfoModal'
import { loginClear } from './redux/auth/auth.action'
import Login from './pages/login/login'
import PortalDeck from './pages/portal-deck/PortalDeck'
import ScreenFlow from './pages/ScreenFlow'
import NotFound from './pages/NotFound'
import Step2 from './pages/Step2'
import Step3 from './pages/Step3'
import CohortBuilderStep1 from './pages/cohort-builder/CohortBuilderStep1'
import CohortBuilderStep2 from './pages/cohort-builder/CohortBuilderStep2'
import CohortBuilderStep3 from './pages/cohort-builder/CohortBuilderStep3'

import { login } from './redux/auth/auth.action'

import './App.scss'

const STATUS_CODES = {
  OK: 200,
  BAD_REQUEST: 400,
}

Amplify.configure(awsExports)

const AppRoutes = () => {
  let routes = useRoutes([
    { path: '/', element: <Login /> },
    /* { path: '/home', element: <Home /> }, */ //sunset wrokflow
    { path: '/portals', element: <PortalDeck /> },
    { path: '/portals/searchflow', element: <PortalDeck /> },
    { path: '/screenflow', element: <ScreenFlow /> },
    { path: '/screenflow-step-2', element: <Step2 /> },
    { path: '/screenflow-step-3', element: <Step3 /> },
    { path: '/cohort-builder-step-1', element: <CohortBuilderStep1 /> },
    { path: '/cohort-builder-step-2', element: <CohortBuilderStep2 /> },
    { path: '/cohort-builder-step-3', element: <CohortBuilderStep3 /> },
    { path: '*', element: <NotFound /> },
  ])

  return routes
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const App = () => {
  const dispatch = useDispatch()

  // const loginState = useSelector((state) => state.loginData.loginResponse)
  // const patientProfileModal = useSelector((state) => state.toggleModals.patientProfileModal)
  // const token = useSelector((state) => state.loginData.loginResponse.accessToken)
  // const reduxAppointmentData = useSelector((state) => state.appointment.appointmentData)
  // const maxData = useSelector((state) => state.appointment.appointmentData.resultCount)
  const vitalsModal = useSelector((state) => state.toggleModals.vitalsModal)
  const labsModal = useSelector((state) => state.toggleModals.labsModal)
  const ecgModal = useSelector((state) => state.toggleModals.ecgModal)
  const holterModal = useSelector((state) => state.toggleModals.holterModal)
  const gxtModal = useSelector((state) => state.toggleModals.gxtModal)
  const echoModal = useSelector((state) => state.toggleModals.echoModal)
  const stressEchoModal = useSelector((state) => state.toggleModals.stressEchoModal)
  const nuclearModal = useSelector((state) => state.toggleModals.nuclearModal)
  const cathModal = useSelector((state) => state.toggleModals.cathModal)
  const ctModal = useSelector((state) => state.toggleModals.ctModal)
  const mriModal = useSelector((state) => state.toggleModals.mriModal)
  const cardiacModal = useSelector((state) => state.toggleModals.cardiacModal)
  const socialModal = useSelector((state) => state.toggleModals.socialModal)
  const familyModal = useSelector((state) => state.toggleModals.familyModal)
  const consultModal = useSelector((state) => state.toggleModals.consultModal)
  const adverseEventModal = useSelector((state) => state.toggleModals.adverseEventModal)
  const intervalModal = useSelector((state) => state?.toggleModals?.intervalModal)
  const physicalModal = useSelector((state) => state?.toggleModals?.physicalModal)
  const medicalHistoryModal = useSelector((state) => state?.toggleModals?.medicalHistoryModal)
  const cardiacHistoryModal = useSelector((state) => state?.toggleModals?.cardiacHistoryModal)
  const cardiacTimelineModal = useSelector((state) => state?.toggleModals?.cardiacTimelineModal)
  const recommendationsModal = useSelector((state) => state?.toggleModals?.recommendationsModal)
  const consultLetterModal = useSelector((state) => state?.toggleModals?.consultLetterModal)
  const screenFlowModal = useSelector((state) => state?.toggleModals?.screenFlowModal)
  const eligibilityCriteriaModal = useSelector((state) => state?.toggleModals?.eligibilityCriteriaModal)
  const appointmentModal = useSelector((state) => state?.toggleModals?.appointmentModal)
  const patientInfoModal = useSelector((state) => state?.toggleModals?.patientInfoModal)
  // const loading = useSelector((state) => state.appointment.loading)
  const alert = useSelector((state) => state.alert)

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const showAlert = (alertType, alertMsg) => {
    dispatch(
      setAlert({
        alertType,
        alertMsg,
        alertOpen: true,
      })
    )
  }
  const handleMessageClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    dispatch(removeAlert())
  }

  useEffect(() => {
    const listener = async (data) => {
      switch (data.payload.event) {
        case 'signIn':
          // User has signed in, update Redux store
          dispatch(loginClear())
          const { signInUserSession } = data.payload.data
          const jwtToken = signInUserSession.getAccessToken().getJwtToken()
          const idToken = signInUserSession.getIdToken().getJwtToken()

          const doLogin = async () => {
            try {
              const headers = {
                accessToken: jwtToken,
                Authorization: `Bearer ${idToken}`,
              }
              const response = await axios.post(
                `${process.env.REACT_APP_SCREENFLOW_BASE_URL}/${process.env.REACT_APP_ENVIRONMENT}/api/login`,
                null,
                { headers }
              )
              if (response?.status === STATUS_CODES.OK) {
                dispatch(login(response?.data))
              } else if (response.data.status >= STATUS_CODES.BAD_REQUEST) {
                showAlert('error', response?.data?.message)
              } else {
                showAlert('error', 'Something went wrong! Please try again.')
              }
            } catch (err) {
              showAlert('error', 'Something went wrong! Please try again.')
              console.error(err)
            }
          }

          doLogin().catch(console.error)

          break
        default:
          console.log(`Unhandled event: ${data.payload.event}`)
          break
      }
    }

    const removeListener = Hub.listen('auth', listener)

    return () => {
      // Clean up listener when component is unmounted
      removeListener()
    }
  }, [dispatch, showAlert])

  return (
    <Authenticator formFields={loginFormFields} components={loginComponents}>
      <Router>
        <AppRoutes />

        <ResetPassword />
        <SessionExpired />
        <AccountDeactivated />
        <ChangePassword />
        {vitalsModal && <VitalModal />}
        {labsModal && <LabsModal />}
        {ecgModal && <EcgModal />}
        {holterModal && <HolterModal />}
        {gxtModal && <GxtModal />}
        {echoModal && <EchoModal />}
        {stressEchoModal && <StressEchoModal />}
        {nuclearModal && <NuclearModal />}
        {cathModal && <CathModal />}
        {ctModal && <CtModal />}
        {mriModal && <MriModal />}
        {cardiacModal && <CardiacModal />}
        {socialModal && <SocialModal />}
        {familyModal && <FamilyModal />}
        {consultModal && <ConsultModal />}
        {adverseEventModal && <AdverseEventModal />}
        {/* {intervalModal && <IntervalModal />} */}
        {/* {physicalModal && <PhysicalModal />} */}
        {medicalHistoryModal && <MedicalHistoryModal />}
        {cardiacHistoryModal && <CardiacHistoryModal />}
        {cardiacTimelineModal && <CardiacTimelineModal />}
        {/* {recommendationsModal && <RecommendationsModal />} */}
        {consultLetterModal && <ConsultLetterModal />}
        {screenFlowModal && <ScreenFlowModal />}
        {eligibilityCriteriaModal && <EligibilityCriteriaModal />}
        {appointmentModal && <AppointmentListModal />}
        {patientInfoModal && <PatientInfoModal />}
        <Snackbar
          disableWindowBlurListener={true}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={alert?.alertOpen}
          autoHideDuration={4000}
          onClose={handleMessageClose}
        >
          <Alert onClose={handleMessageClose} severity={alert?.alertType} sx={{ width: '100%' }}>
            {alert?.alertMsg}
          </Alert>
        </Snackbar>
      </Router>
    </Authenticator>
  )
}

export default App
